<h2 mat-dialog-title>PDF report request</h2>

<mat-dialog-content>
    <form [formGroup]="form" class="manage-pdf-report-request-dialog__form">
        <div class="manage-pdf-report-request-dialog__mode-row">
            <button mat-stroked-button type="button" [color]="form.value.mode === 'create' ? 'primary' : ''"
                (click)="onModeChanged('create')">
                Create new report
            </button>
            <button mat-stroked-button type="button" [color]="form.value.mode === 'update' ? 'primary' : ''"
                [disabled]="existingReports.length === 0" (click)="onModeChanged('update')">
                Update existing report
            </button>
        </div>

        <mat-form-field appearance="outline" *ngIf="form.value.mode === 'update'">
            <mat-label>Existing report</mat-label>
            <mat-select formControlName="selectedReportGuid" (selectionChange)="onSelectedReportChanged($event.value)">
                <mat-option *ngFor="let report of existingReports" [value]="report.reportGuid">
                    {{ report.title || ('Report ' + report.reportGuid) }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls.selectedReportGuid.invalid">Select a report</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Report name</mat-label>
            <input matInput formControlName="title" maxlength="200" />
            <mat-error *ngIf="form.controls.title.invalid">Report name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>File name</mat-label>
            <input matInput formControlName="fileName" maxlength="255" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="3" maxlength="1000"></textarea>
        </mat-form-field>

        <mat-checkbox formControlName="runNow">Run report immediately</mat-checkbox>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="submit()">
        {{ form.value.mode === 'update' ? 'Save' : 'Create' }}
    </button>
</mat-dialog-actions>